<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hYjq4S/tc-custom/9781429971881.jpg?1740716473225" alt="This image is the cover for the book Immortal Surrender, The Curse of the Templars"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Immortal Surrender, The Curse of the Templars
      </h1>
      <p class="bookDescription body article font2">
        <b>A sullen Templar knight cursed with immortality must protect a spitfire scientist in this paranormal romance.</b><br/><br/>Farran de Clare, loyal member of the cursed Knights Templar, wants nothing to do with predestined mates. Even the Almighty won’t turn him into a fool again—he’d rather sacrifice his soul. Yet in the scientist Noelle Keane, a devout atheist, Farran meets the seraph designed for him.<br/><br/>Ordered by the archangel Gabriel to protect Noelle, the possessor of a sacred relic that could give Azazel incredible power, Farran swears to do his duty—but in name only. Fighting an attraction that grows with each day, he’s determined that he’ll never pledge himself to her.<br/><br/>As they war over her future, their mutual passion ignites a conflict far more damning. But before Noelle will agree to eternity with him, she demands the ultimate sacrifice—his heart.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Claire Ashgrove
      </h2>
      
      <p class="authorDescription body article"><P>Claire Ashgrove is an author and a mother to two wonderful boys. In her copious spare time, she raises and trains Oldenburg, Thoroughbred, and Arabian horses.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?11e9e3ac